import CivicSigner from './civicSigner';
import NullSigner from './nullSigner';
import { Signer } from './signer';

const isMock = (process.env.REACT_APP_STAGE || 'unknown') === 'mock';

// return the same signer instance for the lifetime of the app
let signer: Signer;
const getSigner = (instanceId: string, chain?: 'solana' | 'ethereum' | 'casper'): Signer => {
  if (!signer) {
    signer = isMock ? new NullSigner() : new CivicSigner(instanceId, chain);
  }
  return signer;
};

// eslint-disable-next-line import/prefer-default-export
export { getSigner };
